export const SUN_LIFE_INITIATE_PROPOSAL_FORM_ID = 'sun-life-initiate-proposal-form';
export const SUN_LIFE_SIC_WARNING_ALERT_TEST_ID = 'sun-life-initiate-proposal-sic-warning-alert';
export const SUN_LIFE_INCORPORATION_DATE_ALERT_TEST_ID = 'sun-life-initiate-proposal-incorporation-date-alert';
